import { createReducers, createActions } from './utils/reduxUtils';
import { combineReducers } from 'redux';
import { Event, jsonp } from '@ifeng-fe/ui_base';
import isThermogram from './utils/isThermogram';

const path = name => name;

const isThermogramOpen = () => !!window.__visualediting_thermogram;

const mergeAd = () => {
    /* eslint-disable no-undef */
    const chips = typeof __chipsData !== 'undefined' && Array.isArray(__chipsData) ? __chipsData : [];
    const ads = typeof adData === 'object' ? adData : {};
    /* eslint-enable no-undef */

    return chips.map(item => ({
        ...item,
        code: ads[item.key] || '',
    }));
};

const models = {
    devChips: {
        data: mergeAd(),
        handlers: {
            devChipsUpdate(state, action) {
                return action.payload;
            },
        },
    },
    devSearchValue: {
        data: '',
        handlers: {
            devSearchValueUpdate(state, action) {
                return action.payload;
            },
        },
    },
    devGroupHideState: {
        data: {},
        handlers: {
            devGroupHideStateUpdate(state, action) {
                return { ...state, ...action.payload };
            },
        },
    },
    chips: {
        data: [],
        handlers: {
            chipsAdd(state, action) {
                return [...state, action.payload];
            },
            chipsUpdate(state, action) {
                return state.map(item => (item.id === action.payload.id ? action.payload : item));
            },
            chipsDel(state, action) {
                return state.filter(item => item.uid !== action.payload);
            },
            allChipsUpdate(state) {
                console.log('allChipsUpdate');

                return state.map(item => {
                    const rect = document.querySelector(`[data-__chip-target="${item.uid}"]`).getBoundingClientRect();
                    const p = {
                        top: rect.top + document.documentElement.scrollTop,
                        left: rect.left + document.documentElement.scrollLeft,
                        height: rect.height,
                        width: rect.width,
                    };

                    return {
                        ...item,
                        rect: p,
                    };
                });
            },
        },
    },
    currentChipIndex: {
        data: null,
        handlers: {
            currentChipIndexUpdate(state, action) {
                return action.payload;
            },
        },
    },
    chipsHideState: {
        data: {},
        handlers: {
            chipsHideStateUpdate(state, action) {
                return { ...state, ...action.payload };
            },
        },
    },
    dialogData: {
        data: {
            title: '碎片窗口',
            id: '',
            type: '',
        },
        handlers: {
            dialogUpdate(state, action) {
                return { ...state, ...action.payload };
            },
        },
    },
    uiState: {
        data: {
            dialogIsMax: false,
            dialogIsShow: false,
            isPreviewAll: isThermogramOpen() && isThermogram(),
            isPreview: false,
            listIsShow: false,
            devListIsShow: false,
            thermogramListIsShow: isThermogramOpen() && isThermogram(),
            autoFixedThermogram: false,
            autoRefreshThermogram: true,
            isThermogram: isThermogramOpen() && isThermogram(),
            isDialogDraging: false,
            isThermogramOpen: isThermogramOpen(),
            isClearThermogram: false,
            thermogramListIsMini: false,
        },
        handlers: {
            uiStateUpdate(state, action) {
                return { ...state, ...action.payload };
            },
        },
    },
    dialogPosition: {
        data: {
            x: 0,
            y: 0,
        },
        handlers: {
            dialogPositionUpdate(state, action) {
                return action.payload;
            },
        },
    },
    searchValue: {
        data: '',
        handlers: {
            searchValueUpdate(state, action) {
                return action.payload;
            },
        },
    },
    groupHideState: {
        data: {},
        handlers: {
            groupHideStateUpdate(state, action) {
                return { ...state, ...action.payload };
            },
        },
    },
    rqCode: {
        data: {
            preview: '',
            online: '',
        },
        handlers: {
            rqCodeUpdate(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    thermograms: {
        data: [],
        handlers: {
            thermogramsUpdate(state, action) {
                return action.payload;
            },
        },
    },
};

export const actions = createActions(models, path);
export default combineReducers(createReducers(models, path));
export const event = new Event();

// 切换图文视频评论时，更新该页面的字典
export const asyncGetQrcode = (url, type) => {
    return async (dispatch, getState) => {
        try {
            const { qrcode_url } = await jsonp('https://qrcode.ifeng.com/qrcode.php', {
                data: {
                    url,
                },
                cache: true,
                jsonpCallback: `getQrcode_${type}`,
            });

            dispatch(actions.rqCodeUpdate({ [type]: qrcode_url }));
        } catch (e) {
            throw e;
        } finally {
            // dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};

export const asyncGetThermograms = url => {
    return async (dispatch, getState) => {
        try {
            if (
                window.__visualediting_thermogram &&
                window.__visualediting_thermogram.type &&
                window.__visualediting_thermogram.url
            ) {
                const result = await jsonp('https://local.datacenter.ifengidc.com/local/getClickListInfo', {
                    data: {
                        plat: window.__visualediting_thermogram.type,
                        page: window.__visualediting_thermogram.url,
                    },
                    cache: true,
                    jsonpCallback: 'getThermograms',
                });

                if (result.code === 0) {
                    dispatch(actions.thermogramsUpdate(result.data));
                }
            }
        } catch (e) {
            throw e;
        } finally {
            // dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};
